import PropTypes from 'prop-types';
import * as assistantLocalStorage from '../../../utils/AiAssistant/aiAssistantStorage';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import { reduxForm } from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import Checkbox from 'infrastructure/js/components/controls/Checkbox/checkbox';
import TextAreaField from 'infrastructure/js/components/controls/TextAreaField/textAreaField';
import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';
import RadioButton from 'infrastructure/js/components/controls/RadioButton/radioButton';
import Validation from 'infrastructure/js/components/controls/controlsValidations';

import './aiiAssistantFeedbackDialog.scss';

const getFeedbackReasons = () => {
  return [
    {value: getEnumValue(enumTypes.FEEDBACK_REASON_TYPE)('INCORRECT_INFO'), label: getEnumLabel(enumTypes.FEEDBACK_REASON_TYPE)('INCORRECT_INFO')},
    {value: getEnumValue(enumTypes.FEEDBACK_REASON_TYPE)('WRONG_ACTION'), label: getEnumLabel(enumTypes.FEEDBACK_REASON_TYPE)('WRONG_ACTION')},
    {value: getEnumValue(enumTypes.FEEDBACK_REASON_TYPE)('NOT_RELEVANT'), label: getEnumLabel(enumTypes.FEEDBACK_REASON_TYPE)('NOT_RELEVANT')},
    {value: getEnumValue(enumTypes.FEEDBACK_REASON_TYPE)('SLOW'), label: getEnumLabel(enumTypes.FEEDBACK_REASON_TYPE)('SLOW')},
    {value: getEnumValue(enumTypes.FEEDBACK_REASON_TYPE)('OTHER'), label: getEnumLabel(enumTypes.FEEDBACK_REASON_TYPE)('OTHER')},
  ]
}

const privacyPolicyLink =  'https://plataine.zendesk.com/'; //TODO: L - replace with a relevant url
// const privacyPolicyLink =  '';


export function AiiAssistantFeedbackDialog({
                                             actions,
                                             sData,
                                             handleSubmit
}) {
  const dialogLabels = createLabelHelper('mat.dialog.');
  const labels = createLabelHelper('mat.ai.assistant.feedback.dialog.');

  const dialogMode = sData?.get('dialogData')?.mode;

  const onSubmit = (data) => {
    const sessionId = assistantLocalStorage.loadSessionId();
    const dialogData = sData?.get('dialogData');
    const onSuccess = dialogData?.onSuccess;

    let newData = {
      sessionId,
      feedbackType: dialogMode === 'up',
      reasonType: data.reasonType,
      lastPrompt: dialogData?.lastPrompt || '',
      description: data.feedback,
      canContact: data.canContact,
    };

    actions.submit(newData, null, onSuccess);
  };

  const onHide = () => {
    actions.hide();
  };

  const getDialogButtons = () => {
    return {
      left: [
        {
          id: 'cancel',
          text: dialogLabels.get('cancel'),
          action: actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: labels.get('button.submit'),
          bsStyle: 'primary',
          loading: sData.get('loading'),
          action: handleSubmit(onSubmit),
          disabled: sData.get('loading'),
        },
      ],
    };
  };

  const getPrivacyPolicyLink = () => {

    return (
      <span className='privacy-policy-label'>
        <label htmlFor="canContact">{labels.get('canContact')}</label>
        {privacyPolicyLink && <label>{labels.get('seeOur')}</label>}
        {privacyPolicyLink && <label className="privacy-policy-link"
                                     onClick={() => window.open(privacyPolicyLink, '_blank')}>
                                {labels.get('privacyPolicy')}
                              </label>}
      </span>);
  }

  return (
    <Dialog
      id="ai-assistant-feedback-dialog"
      className="ai-assistant-feedback-dialog"
      titleText={dialogMode === 'up' ? labels.get('title.positive') : labels.get('title.negative')}
      show={true}
      onHide={onHide}
      sData={sData}
      footerButtons={getDialogButtons()}
      // onEnterKeyPress={handleSubmit(onSubmit)}
    >
      {dialogMode === 'down' &&
        <InputSection label={labels.get('reason') + '*'} htmlFor="reasonType" className="no-margin">
          <RadioButton id="reasonType" name="reasonType" className=""
                       labelsAndValues={getFeedbackReasons()}
                       validate={Validation.required}
          />
        </InputSection>}

      {/*<InputSection htmlFor="includePromptAndResponse" className={dialogMode === 'up' ? 'no-margin' : ''}>*/}
      {/*  <Checkbox id="includePromptAndResponse" name="includePromptAndResponse" label={labels.get('includePromptAndResponse')} />*/}
      {/*</InputSection>*/}

      <InputSection htmlFor="feedback" className=""
                    label={dialogMode === 'up' ? labels.get('positive.feedback') : labels.get('negative.feedback')}>
        <TextAreaField id="feedback" name="feedback" rows={5}
                       placeholder={dialogMode === 'up' ? labels.get('positive.feedback.placeholder') : labels.get('negative.feedback.placeholder')}/>
      </InputSection>

      <InputSection className="" label={''}>
        <Checkbox id="canContact" name="canContact" label={getPrivacyPolicyLink()}/>
      </InputSection>
    </Dialog>
  );
}

AiiAssistantFeedbackDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'aiAssistantFeedbackDialog',
})(AiiAssistantFeedbackDialog);
